var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"text-center mt-5 pt-5"},[_vm._m(0)]):_c('Videos',{attrs:{"audioContents":_vm.audioContents,"imageContents":_vm.imageContents,"videoContents":_vm.videoContents}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-grow text-dark m-5 p-5 text-center",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }